module.exports = {
    disabled: 0,
    body: function (query, post) {
        return {
            data: '',
            msg: '',
            status: 0
        }
    }
}
